import { LandUnit } from 'types/Property';

export const formatLandUnit = (unit: LandUnit | string): string => {
  if (!unit) return '';
  if (unit === 'm2') return `m²`;

  return unit;
};
